<template>
  <div>
    <v-card
      light
      v-for="(item, index) in projets"
      :key="index"
      class="mb-4 teal lighten-5"
    >
      <v-card-title>{{ item.ll_programme }}</v-card-title>
      <v-card-text
        >{{ item.objectifs }}

        <Activites :projet="item" />
      </v-card-text>
      <v-card-actions>
        <v-btn outlined rounded>
          <v-icon>mdi-plus-circle-outline</v-icon>
          Activité
        </v-btn>

        <v-btn icon outlined>
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn icon outlined>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Activites: require("@/components/organisation/activites").default,
  },
  created() {
    this.getProjetData(this.bailleur.id);
  },
  data() {
    return {
      projets: [],
    };
  },
  props: {
    bailleur: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getProjetData(bailleur) {
      // console.log(this.$route.params.bailleur.id);
      //console.log(this.$firebase.auth().currentUser.uid);
      let self = this;

      this.$firebase
        .firestore()
        .collection("projets")
        .where("id_bailleur", "==", bailleur.toString())
        .get()
        .then((snapshot) => {
         

          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.projets.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
              //commit("Loading/END_BUSY_STATE", "projets.store.js", { root: true });
            }
            if (change.type === "modified") {
              let obj = self.projets.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
      /*   .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            self.projets.push({
              ...doc.data(),
              id: doc.id,
            });
            //console.log(self.projets);
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        }); */
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
